import jwtService from 'app/auth/store/actions/jwtService';
import decode from 'jwt-decode';
import { USER_ROLE } from 'app/main/util/enums';

export const getDefaultRoute = () => {
    try {
        const token = jwtService.getAccessToken()
        const decoded = decode(token)
        const user = decoded.user
        // Demo users land on the campaign landing page only when they
        // actually came in through a campaign. Portal-provisioned trial
        // users also get the demo role (so the authz default-deny covers
        // them) but have no campaignId - they belong on the dashboard.
        if (user.role.includes(USER_ROLE.DEMO) && user.campaignId) return '/landing-page'
        if (user.role.includes(USER_ROLE.INSTRUCTOR)) return '/trainings'
        if (user.role.includes(USER_ROLE.PARTICIPANT)) return '/workshop-dashboard'  // Participants should land on workshop dashboard
        // All authenticated users (admin and non-admin) go to dashboard
        return '/dashboard'
    } catch (error) {
        return '/dashboard'
    }
}